import { QuestionType } from "../../../api/main/models/codeOnly/QuestionType";
import { DeleteQuestionBase } from "../DeleteQuestionBase";

/**
 * Delete an information page.
 */
export const DeleteInformation = () => (<DeleteQuestionBase defaultQuestionType={QuestionType.InformationVideo} />);
